/** Santykinis kelias — statinis failas gamyboje. */
export const APK_DOWNLOAD_PATH = '/downloads/imreapp.apk';

/** Patikimesnis atsisiuntimas planšetėje (ypač dev / LAN). */
export const APK_API_DOWNLOAD_PATH = '/api/apk/download';

export const PRODUCTION_APP_ORIGIN = 'https://imre2.indevi.eu';

export function productionApkUrl(): string {
  return `${PRODUCTION_APP_ORIGIN}${APK_DOWNLOAD_PATH}`;
}
